import {ModuleFormat} from "../../constants/ModuleFormat";

export const getCourseFormatName = (format: ModuleFormat, t: any) => {
    switch (format) {
        case ModuleFormat.PreRecorded:
            return t('my_courses.online');
        case ModuleFormat.Offline:
            return t('my_courses.offline');
        default:
            return t('my_courses.online');
    }
}import {ModuleFormat} from "../../constants/ModuleFormat";

export const getCourseFormatName = (format: ModuleFormat, t: any) => {
    switch (format) {
        case ModuleFormat.PreRecorded:
            return t('my_courses.online');
        case ModuleFormat.Offline:
            return t('my_courses.offline');
        default:
            return t('my_courses.online');
    }
}